import React from 'react';
import Icon from '../../../components/AppIcon';

const ComplianceStatus = ({ standards }) => {
  const getStandardConfig = (standard) => {
    switch (standard) {
      case 'HIPAA':
        return {
          color: 'var(--color-primary)',
          icon: 'Shield',
          description: 'Health Insurance Portability and Accountability Act'
        };
      case 'SOC2':
        return {
          color: 'var(--color-success)',
          icon: 'Lock',
          description: 'Service Organization Control 2 Type II Certified'
        };
      case 'GDPR':
        return {
          color: 'var(--color-accent)',
          icon: 'Globe',
          description: 'General Data Protection Regulation Compliant'
        };
      default:
        return {
          color: 'var(--color-muted-foreground)',
          icon: 'CheckCircle',
          description: standard
        };
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Compliance Standards</h3>
      <div className="space-y-3">
        {standards?.map(standard => {
          const config = getStandardConfig(standard);
          return (
            <div key={standard} className="flex items-start gap-3">
              <div
                className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: `${config?.color}20` }}
              >
                <Icon name={config?.icon} size={20} style={{ color: config?.color }} />
              </div>
              <div className="flex-1">
                <h4 className="font-semibold text-foreground mb-1">{standard}</h4>
                <p className="text-sm text-muted-foreground">{config?.description}</p>
              </div>
              <Icon name="CheckCircle" size={20} className="text-success flex-shrink-0" />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ComplianceStatus;